import React, { useEffect, useState } from 'react';
import { Image, View, StyleSheet, TouchableOpacity, Text } from 'react-native';
import { greenDot, Icons } from '../../assets';
import ModalWrapper from '../../components/ModalWrapper/ModalWrapper';
import { useNavigation } from '@react-navigation/native';
import { useGlobalState } from '../../shared/state';
import { I18N } from '../../shared/util';
import { Fonts, Styles } from '../../styles';


const LogoutModal: React.FC = (): JSX.Element => {
  const [, setCurrentScreen] = useGlobalState('currentScreen');
  const [currentUser, setCurrentUser] = useGlobalState('currentUser');
  const [, setCurrentMeasurements] = useGlobalState('currentMeasurements');
  const [, setMatchedProducts] = useGlobalState('matchedProducts');
  const [, setInitialMatchedProducts] = useGlobalState("initialMatchedProducts");
  const [, setAllProducts] = useGlobalState('allProducts');
  const [, setCurrentScan] = useGlobalState('currentScan');
  const [, setModalIsDisplayed] = useGlobalState('modalIsDisplayed');
  const [userToken, setUserToken] = useGlobalState('userToken');
  const [language] = useGlobalState('language');
  const [userInfo, setUserInfo] = useState<string | undefined>(undefined);
  const [Colors] = useGlobalState('colors');

  const i18n = I18N(language);
  const navigation = useNavigation();

  const onLogout = () => {
    setCurrentUser(undefined);
    setUserToken(undefined)
    setCurrentMeasurements(undefined)
    setMatchedProducts(undefined)
    setInitialMatchedProducts(undefined)
    setCurrentScan(undefined)
    setAllProducts([])
    setCurrentScreen('Home');
    navigation.navigate('Home');
  };

  useEffect(() => {
    setUserInfo(userToken
      ? currentUser.firstName.length > 0 && currentUser.lastName.length > 0
        ? `${currentUser.firstName} ${currentUser.lastName}`
        : currentUser.email
      : currentUser && currentUser.employeeNumber
        ? currentUser.employeeNumber
        : '')
  }, [])

  return (
    <ModalWrapper title={i18n.t('auth.logOut')}>
      <View style={styles.container}>
        <View style={styles.content}>
          <View style={styles.iconsContainer}>
            <Image style={styles.greenDotWrapper} source={greenDot} />
            <Image style={styles.iconWrapper} source={Icons.loginIconOutlined} />
          </View>
          <Text style={styles.userInfoText}> {userInfo} </Text>
          <View style={styles.divider} />
          <Text style={styles.logoutModalText}>
            {i18n.t('auth.logoutMessage')}
          </Text>
          <TouchableOpacity style={Styles.submitButtonDark} onPress={() => onLogout()}>
            <Text style={[styles.buttonText, { ...Colors.white }]}>{i18n.t('auth.logOut')}</Text>
          </TouchableOpacity>
          <TouchableOpacity style={Styles.submitButtonLight} onPress={() => [setModalIsDisplayed(false), navigation.goBack(null)]}>
            <Text style={[styles.buttonText, { ...Colors.black }]}>{i18n.t('auth.stayConnected')}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </ModalWrapper>
  );
};

export default LogoutModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center'
  },
  content: {
    width: '25%',
    height: '70%',
    paddingTop: '5%',
    justifyContent: 'space-evenly'
  },
  iconsContainer: {
    width: '45%',
    height: '25%',
    alignSelf: 'center'
  },
  greenDotWrapper: {
    alignSelf: 'flex-end',
    width: '15%',
    height: '15%',
    resizeMode: 'contain'
  },
  iconWrapper: {
    flex: 1,
    resizeMode: 'contain',
    alignSelf: 'center'
  },
  divider: {
    width: '90%',
    alignSelf: 'center',
    borderTopColor: '#707070',
    borderTopWidth: 1
  },
  logoutModalText: {
    ...Fonts.mRegular,
    ...Fonts.size16,
    textAlign: 'center',
    fontWeight: "normal"
  },
  userInfoText: {
    ...Fonts.center,
    ...Fonts.mRegular,
    ...Fonts.size16,
    fontWeight: "normal",
  },
  buttonText: {
    ...Fonts.mRegular,
    ...Fonts.size12,
    ...Fonts.center,
    textTransform: 'uppercase'
  }
});
